import { loggerService } from './Logger';
import api from './api'

export const authService = {
  checkEmail: async (email: string) => {
    if (!email) {
      throw new Error("Email is required");
    }
    const { data } = await api.post("/auth/check-email", { email });
    return data;
  },

  signUp: async (formData: any) => {
    const { data } = await api.post("/auth/signup", {
      email: formData.email,
      password: formData.password,
      firstName: formData.given_name,
      lastName: formData.family_name,
      phoneNumber: formData.phone_number,
      streetAddress: formData.street_address,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      postalCode: formData.postal_code,
      companyName: formData.company_name,
      companyTitle: formData.company_title,
      companyPhoneNumber: formData.company_phone_number,
      companyStreetAddress: formData.company_street_address,
      companyCity: formData.company_city,
      companyState: formData.company_state,
      companyCountry: formData.company_country,
      companyPostalCode: formData.company_postal_code,
    });
    try {
      await loggerService.log('auth', 'signup_success', { email: formData.email });
    } catch (error) { }
    return data;
  },



  signIn: async (email: string, password: string) => {
    const { data } = await api.post("/auth/signin", { email, password });
    try {
      await loggerService.log('auth', 'signin_success', { email });
    } catch (error) {
      console.error('Logging failed:', error);
    }
    return data;
  },

  verifyEmail: async (code: string, email: string) => {
    const { data } = await api.post(`/auth/verify-email/${code}`, { email });
    try {
      await loggerService.log('auth', 'email_verification', { email });
    } catch (error) { }

    return data;
  },

  resendVerification: async (email: string) => {
    const { data } = await api.post("/auth/resend-verification", { email });
    try {
      await loggerService.log('auth', 'verification_resend', { email });
    } catch (error) { }

    return data;
  },

  requestPasswordChange: async () => {
    const token = localStorage.getItem("token");
    const { data } = await api.post("/auth/request-password-change", null, {
      headers: { Authorization: `Bearer ${token}` },
    });
    try {
      await loggerService.log('auth', 'password_change_request', {});
    } catch (error) { }
    return data;
  }
};
